// Author Liang Gang Qiang
// Date 2021-10-15 09:54:24

class ImfMstShiftRule {
constructor({
        id = null,
        name = '',
        ruleType = '',
        loopRule = '',
        switchingCycle = '',
        beginTime = '',
        eachShiftDuration = '',
        eachShiftRatedWorkingHours = '',
        remark = ''}
= {}) {
    this.id = id;
    this.name = name;
    this.ruleType = ruleType;
    this.loopRule = loopRule;
    this.switchingCycle = switchingCycle;
    this.beginTime = beginTime;
    this.eachShiftDuration = eachShiftDuration;
    this.eachShiftRatedWorkingHours = eachShiftRatedWorkingHours;
    this.remark = remark;
}
}

function newEntity() {
return new ImfMstShiftRule();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.admin.imfMstShiftRule.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'name',
        label: 'label.em.admin.imfMstShiftRule.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'ruleType',
        label: 'label.em.admin.imfMstShiftRule.grid.ruleType',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '1', text: '节假日休息' },
                            { value: '2', text: '节假日不休息' }
            ]
        }
        },
        {
        key: 'loopRule',
        label: 'label.em.admin.imfMstShiftRule.grid.loopRule',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'switchingCycle',
        label: 'label.em.admin.imfMstShiftRule.grid.switchingCycle',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'beginTime',
        label: 'label.em.admin.imfMstShiftRule.grid.beginTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'eachShiftDuration',
        label: 'label.em.admin.imfMstShiftRule.grid.eachShiftDuration',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'eachShiftRatedWorkingHours',
        label: 'label.em.admin.imfMstShiftRule.grid.eachShiftRatedWorkingHours',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.em.admin.imfMstShiftRule.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    nameFilter : "",
    ruleTypeFilter : "",
    loopRuleFilter : "",
    eachShiftRatedWorkingHoursFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'nameFilter',
        label: 'label.em.admin.imfMstShiftRule.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'ruleTypeFilter',
        label: 'label.em.admin.imfMstShiftRule.filter.ruleType',
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: '节假日休息' },
                { value: '2', text: '节假日不休息' }
            ]
        }
        },
        {
        key: 'loopRuleFilter',
        label: 'label.em.admin.imfMstShiftRule.filter.loopRule',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'eachShiftRatedWorkingHoursFilter',
        label: 'label.em.admin.imfMstShiftRule.filter.eachShiftRatedWorkingHours',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'name',
        label: 'label.em.admin.imfMstShiftRule.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'ruleType',
        label: 'label.em.admin.imfMstShiftRule.entity.ruleType',
        sortable: true,
        disabled: false,
        form: {
        type: 'select'
            ,required: true
            ,showLabelSelectOne: true
        ,options: [
                { value: '1', text: '节假日休息' },
                { value: '2', text: '节假日不休息' }
            ]
        }
        },
        {
        key: 'loopRule',
        label: 'label.em.admin.imfMstShiftRule.entity.loopRule',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'switchingCycle',
        label: 'label.em.admin.imfMstShiftRule.entity.switchingCycle',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'beginTime',
        label: 'label.em.admin.imfMstShiftRule.entity.beginTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datetimepicker'
            ,required: true
                }
        },
        {
        key: 'eachShiftDuration',
        label: 'label.em.admin.imfMstShiftRule.entity.eachShiftDuration',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
            ,required: true
                }
        },
        {
        key: 'eachShiftRatedWorkingHours',
        label: 'label.em.admin.imfMstShiftRule.entity.eachShiftRatedWorkingHours',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
            ,required: true
                }
        },
        {
        key: 'remark',
        label: 'label.em.admin.imfMstShiftRule.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {ImfMstShiftRule, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
